import React, { useState, useEffect } from "react"

import useWindowDimensions from "../../utils/useWindowDimensions"

import {
  Section,
  Wrapper,
  Text,
  Heading,
  Subhead,
  TableWrapper,
} from "./styles/Table.styled"

const Table = ({ component }) => {
  const [showMobileTable, setShowMobileTable] = useState(null)
  const mobileTable = component?.optionMobileTable
  const noBorder = component?.optionRemoveBorder
  const { width } = useWindowDimensions()
  const background = component?.background?.toLowerCase()

  useEffect(() => {
    if (mobileTable && width < 577) {
      setShowMobileTable(true)
    } else {
      setShowMobileTable(false)
    }
  }, [width, mobileTable])

  return (
    <Section background={background}>
      <Wrapper>
        {(component?.heading || component?.subheading) && (
          <Text>
            {component?.heading && (
              <Heading background={background}>{component?.heading}</Heading>
            )}
            {component?.subheading && (
              <Subhead background={background}>{component?.subhead}</Subhead>
            )}
          </Text>
        )}
        <TableWrapper background={background} noBorder={noBorder}>
          {!showMobileTable && (
            <div dangerouslySetInnerHTML={{ __html: component?.table }} />
          )}
          {showMobileTable && (
            <div dangerouslySetInnerHTML={{ __html: component?.mobileTable }} />
          )}
          <div
            className="note"
            dangerouslySetInnerHTML={{ __html: component?.note }}
          />
        </TableWrapper>
      </Wrapper>
    </Section>
  )
}

export default Table
